import { FC } from 'react';
import GroupedDocsTable from 'components/table/documents/GroupedDocsTable';
import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => {
  return (
    <InnerWrapper>
      <GroupedDocsTable
        entityName="my-documents-received"
        entityEndpoint="document-holders"
        searchParams={{
          tab: 'received',
        }}
      />
    </InnerWrapper>
  );
};

export default Screen;
